import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Host, HostDetail, HostId, NewHost, PendingHostChanges } from '@portal-front-end/models';
import { Update } from '@ngrx/entity';

@Injectable({ providedIn: 'root' })

export class HostsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly HOST_URL = `${this.apiServer}/hosts`;

    getHostById(hostId: HostId): Observable<Host> {
        return this.http.get<Host>(`${this.HOST_URL}${hostId}`);
    }

    getHosts(): Observable<Host[]> {
        return this.http.get<Host[]>(this.HOST_URL);
    }

    getActiveHosts(): Observable<Host[]> {
        return this.http.get<Host[]>(`${this.HOST_URL}`, {
            params:
            {
                "statusId": "1"
            }
        });
    }

    updateHost(payload: Host, hostId: HostId): Observable<Host> {
        return this.http.put<Host>(`${this.HOST_URL}/${hostId}`, payload);
    }

    insertHost(object: Host): Observable<Host> {
        return this.http.post<Host>(this.HOST_URL, object);
    }

    getPendingChanges(): Observable<PendingHostChanges> {
        return this.http.get<PendingHostChanges>(`${this.HOST_URL}/pending-count`);
    }

    hostPendingChanges(supplierOrgIdList:number[]): Observable<Host> {
        return this.http.post<Host>(`${this.HOST_URL}/send-pending-changes`, 
        {
            supplierOrgIdList:supplierOrgIdList
        });
    }

    getPendingHostDetails(isStore: boolean): Observable<HostDetail> {
        return this.http.get<HostDetail>(`${this.HOST_URL}/pending-host-details`, {
            params: {
                'byStore': isStore.toString()
            }
        });
    }

    getHostDetails(hostId: string, isStore: boolean): Observable<HostDetail> {
        return this.http.get<HostDetail>(`${this.HOST_URL}/host-details`, {
            params: {
                'hostId': hostId,
                'byStore': isStore.toString()
            }
        });
    }

    refreshHost(hostName: string, comment: string, storeIdList: string[]): Observable<NewHost> {
        return this.http.post<NewHost>(`${this.HOST_URL}/refresh-host`,
            {
                'hostName': hostName,
                'comment': comment,
                'storeIdList': storeIdList
            }
        );
    }

    // Regenerate and resend a Host record.
    resendHost(hostId: string): Observable<Host> {
        return this.http.post<Host>(`${this.HOST_URL}/resend-host`, null, {
            params: {
                'hostId': hostId
            }
        });
    }
}
